import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";
import { ResellerDetails } from "../../resellers.types";

export const requestGetResellerById = async (
  resellerId: string
): Promise<ResellerDetails> => {
  return await instance.get(buildUrl(ApiRoutesResellers.Reseller, resellerId));
};
